__webpack_require__.p = "https://tta-dev.tta-dc5-dev.dtek.cloud/";